// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1s1Qu","subheader":"ReorderModal_subheader__2KD2F","listWrap":"ReorderModal_listWrap__3X4br"};